import { render, staticRenderFns } from "./TreatmentAreas.vue?vue&type=template&id=5ed0c338&"
import script from "./TreatmentAreas.vue?vue&type=script&lang=js&"
export * from "./TreatmentAreas.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentAreas.vue?vue&type=style&index=0&id=5ed0c338&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports